import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'motion/react';

export function FinleyInsightBanner({ message, visible }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!visible || !message) return;
    setShow(true);
    const t = setTimeout(() => setShow(false), 2800);
    return () => clearTimeout(t);
  }, [visible, message]);

  return (
    <AnimatePresence>
      {show && message && (
        <motion.div
          initial={{ opacity: 0, y: -12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2, ease: 'easeOut' }}
          className="pointer-events-none absolute left-3 right-3 top-3 z-40"
        >
          <div className="flex min-h-[48px] items-center gap-2 rounded-finley-full border border-white/30 bg-white/70 px-4 py-2 shadow-finley-md backdrop-blur-md">
            <span className="text-lg">✨</span>
            <span className="text-sm leading-5 text-finley-text">{message}</span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
